import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// DELETE a project
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestDeleteProject = packet => {
  return {
    type: 'REQUEST_DELETE_PROJECT',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveDeleteProjectSuccess = data => ({
  type: 'RECEIVE_DELETE_PROJECT_SUCCESS',
  data
})

export const receiveDeleteProjectFail = data => ({
  type: 'RECEIVE_DELETE_PROJECT_FAIL',
  data
})

export const tryToDeleteProject = packet => (dispatch, getState) => {

  dispatch(requestDeleteProject(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/projects/' + packet.id, {
      method: 'delete',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(push('/workbench/' + packet.scope));
      dispatch(receiveDeleteProjectSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveDeleteProjectFail({errors:e, lastSubmit: packet}));
    })
}
